// extracted by mini-css-extract-plugin
export default {"blogs-section":"BlogsSection_blogs-section__Al0R4"};